import { Client, Storage } from "appwrite";

const client = new Client()
  .setEndpoint("https://fra.cloud.appwrite.io/v1")
  .setProject("6aa70e7b000a03219492");

export const appwriteStorage = new Storage(client);
export const appwriteBucketId = "6aa72b7e00201e6bbe4a";

export const getAppwriteFileUrl = (fileId) =>
  `${"https://fra.cloud.appwrite.io/v1"}/storage/buckets/${appwriteBucketId}/files/${fileId}/view?project=6aa70e7b000a03219492`;

export const uploadAARFile = (file) =>
  appwriteStorage.createFile(
    appwriteBucketId,
    "unique()",
    file
  );

export const getAARFile = (fileId) =>
  appwriteStorage.getFile(appwriteBucketId, fileId);